import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  popperContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    overflow: "hidden",
    pointerEvents: "none", // Prevent interaction
  },
  confetti: {
    position: "absolute",
    width: "10px",
    height: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    animation: "$fall 3s linear infinite",
    borderRadius: "50%",
  },
  "@keyframes fall": {
    "0%": {
      transform: "translateY(-100px) rotate(0deg)",
      opacity: 1,
    },
    "100%": {
      transform: "translateY(100vh) rotate(360deg)",
      opacity: 0,
    },
  },
}));

const BirthdayPopper = ({ open }) => {
  const classes = useStyles();
  const [showPopper, setShowPopper] = useState(false);

  // Function to check if today is the birthday
  const isTodayBirthday = () => {
    const birthday = "2024-11-27"; // Replace with dynamic birthday (YYYY-MM-DD)
    const today = new Date().toISOString().split("T")[0];
    return birthday === today;
  };

  // Generate confetti data
  const generateConfetti = () => {
    const confettiArray = [];
    for (let i = 0; i < 50; i++) {
      confettiArray.push({
        left: `${Math.random() * 100}vw`,
        animationDelay: `${Math.random() * 2}s`,
        backgroundColor: `hsl(${Math.random() * 360}, 100%, 50%)`,
      });
    }
    return confettiArray;
  };

  return (
    <div>
      {open && (
        <div className={classes.popperContainer}>
          {generateConfetti().map((style, index) => (
            <div
              key={index}
              className={classes.confetti}
              style={{
                left: style.left,
                animationDelay: style.animationDelay,
                backgroundColor: style.backgroundColor,
              }}
            ></div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BirthdayPopper;
